import Extent from '@arcgis/core/geometry/Extent';
import { extentFromPoint, mergeExtents } from '../../../shared/map/plugins/utils/merge-extents';
import { graphicPoint, polygonFromExtent } from '../../../sketch-editor/graphic-elements';
import { buildGraphic } from '../../../sketch-editor/graphics-handler';
import { GeometricShape } from '../../../types/geo';
import { DEFAULT_COLOR } from '../../../sketch-editor/colorizer';

interface RepeatableMapViewFeature {
  geometry?: GeometricShape | {
    item?: {
      geometry?: GeometricShape
    },
  }
}

const extentFromGeometry = (geometry) => (buildGraphic(geometry).geometry.extent);

const GraphicForExtents = (features, lastEditorMapExtents) => {
  let extent;

  const geometries: GeometricShape[] = [];
  features?.forEach((feature: RepeatableMapViewFeature) => {
    if (feature.geometry?.item?.geometry) {
      geometries.push(feature.geometry?.item?.geometry);
    } else if (feature?.geometry && !feature?.geometry?.item) {
      geometries.push(feature.geometry as GeometricShape);
    }
  });

  if (geometries.length === 0) {
    if (lastEditorMapExtents) {
      extent = new Extent({ ...lastEditorMapExtents });
    }
  } else {
    geometries.forEach((geometry) => {
      if (!extent) {
        extent = extentFromGeometry(geometry);
        if (!extent) {
          // We must have a point
          extent = extentFromPoint(geometry);
        }
      } else {
        mergeExtents(extent, geometry);
      }
    });
  }
  if (extent) {
    const {
      xmin, xmax, ymin, ymax, spatialReference,
    } = extent;

    if (xmin === xmax && ymin === ymax) {
      return graphicPoint({ x: xmin, y: ymin, spatialReference }, DEFAULT_COLOR);
    }

    return polygonFromExtent(extent);
  }

  return undefined;
};

export default GraphicForExtents;
